import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const exportData = async (data, fileName, format) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
        console.error("No data available to export");
        return;
    }

    console.log(`Starting ${format.toUpperCase()} export with ${data.length} records`);

    if (format === 'csv') {
        try {
            // Extract headers from the first item
            const headers = Object.keys(data[0]);
            
            // Create CSV rows
            const csvRows = [];
            csvRows.push(headers.join(','));

            // Process data in chunks to avoid memory issues
            const chunkSize = 1000;
            for (let i = 0; i < data.length; i += chunkSize) {
                const chunk = data.slice(i, i + chunkSize);
                chunk.forEach(row => {
                    const values = headers.map(header => {
                        const value = row[header] || '';
                        const escaped = value.toString().replace(/"/g, '""');
                        return `"${escaped}"`;
                    });
                    csvRows.push(values.join(','));
                });
                console.log(`Processed ${Math.min(i + chunkSize, data.length)} of ${data.length} records`);
            }

            // Create and download the CSV file
            const csvString = csvRows.join('\n');
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', `${fileName}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            console.log(`Successfully exported ${data.length} records to CSV`);
        } catch (error) {
            console.error("Error creating CSV:", error);
            throw error;
        }
    } else if (format === 'pdf') {
        try {
            const doc = new jsPDF('landscape');
            doc.text('Exported Data', 10, 10);

            const headers = Object.keys(data[0]).filter(key => !key.includes('URL'));
            const links = [];

            // Process data in chunks to avoid memory issues
            const chunkSize = 100;
            const tableData = [];

            for (let i = 0; i < data.length; i += chunkSize) {
                const chunk = data.slice(i, i + chunkSize);
                const chunkData = chunk.map((row, rowIndex) => {
                    const absoluteRowIndex = i + rowIndex;
                    return headers.map((header, colIndex) => {
                        if (header === 'Bill #' && row['Bill URL'] !== 'Not Available') {
                            links.push({
                                row: absoluteRowIndex,
                                col: colIndex,
                                url: row['Bill URL']
                            });
                            return row[header];
                        }
                        if (header === 'LC #' && row['LC URL'] !== 'Not Available') {
                            links.push({
                                row: absoluteRowIndex,
                                col: colIndex,
                                url: row['LC URL']
                            });
                            return row[header];
                        }
                        return row[header];
                    });
                });
                tableData.push(...chunkData);
                console.log(`Processed ${Math.min(i + chunkSize, data.length)} of ${data.length} records for PDF`);
            }

            doc.autoTable({
                head: [headers],
                body: tableData,
                didDrawCell: function(data) {
                    const columnHeader = headers[data.column.index];
                    if (columnHeader === 'Bill #' || columnHeader === 'LC #') {
                        doc.setTextColor(0, 0, 255);
                        doc.setFont('helvetica', 'normal', 'underline');
                    }

                    if (data.section === 'body') {
                        links.forEach(link => {
                            if (link.row === data.row.index && link.col === data.column.index) {
                                doc.link(
                                    data.cell.x,
                                    data.cell.y,
                                    data.cell.width,
                                    data.cell.height,
                                    { url: link.url }
                                );
                            }
                        });
                    }

                    doc.setTextColor(0, 0, 0);
                    doc.setFont('helvetica', 'normal');
                },
                styles: { fontSize: 8 },
                columnStyles: {
                    0: { cellWidth: 'auto' },
                    1: { cellWidth: 'auto' },
                    2: { cellWidth: 'auto' },
                    3: { cellWidth: 'auto' },
                    4: { cellWidth: 'auto' },
                    5: { cellWidth: 'auto' }
                }
            });

            doc.save(`${fileName}.pdf`);
            console.log(`Successfully exported ${data.length} records to PDF`);
        } catch (error) {
            console.error("Error creating PDF:", error);
            throw error;
        }
    } else if (format === 'print') {
        const comments = document.querySelectorAll('.comment');
        comments.forEach(comment => comment.remove());
        window.print();
    } else {
        console.error('Unsupported export format');
        throw new Error('Unsupported export format');
    }
};